import { String } from 'lodash'
import { request } from '../request'
// 模板列表
export interface GetTplList {
  keyword?: string
  resource_tag_ids?: string[]
  // limit: number
  // page: number
}
export const getTplList = (data: GetTplList) =>
  request('/portal/verify/dataProtection/templateList', {
    params: data,
  })
// 创建任务-安全域列表
export const targetList = () => request('/portal/verify/dataProtection/targetList')
// 创建任务
export interface CreateTask {
  name: string
  agent_id: string
  hostname: string
  host_id: string
  biz_area_name: string
  scheduler_type: number
  days: string
  day_of_week: string
  task_time: string
  template_id: string
  action_list: number
  replace_dict: string
  dynamic_dict: string
  file_type: number
  file_format_list: number[]
  compress_type_list: number[]
  leak_type_list: number[]
  compress_password: string
  timeout: number
}
export const createTask = (data: CreateTask) =>
  request('/portal/verify/dataProtection/createTask', {
    method: 'POST',
    data,
  })
// 创建任务模板解析
export interface TaskTemplate {
  id: string
}
export const taskTemplate = (data: TaskTemplate) =>
  request(`/portal/verify/dataProtection/templateContent`, {
    params: data,
  })
// 获取模板详情
export interface TemplateDetail {
  id: string
}
export interface ResultTemplateDetail {
  task_id: string
  result_id?: string
}
export const getTemplateDetail = (data: TemplateDetail) =>
  request(`/portal/verify/dataProtection/templateDetail/${data.id}`, {
    params: data,
  })

export const getResultTemplateDetail = (data: ResultTemplateDetail) =>
  request(`/portal/verify/dataProtection/resultTemplateDetail`, {
    params: data,
  })

// 树结构标签选项
export const getTagTreeOptions = data =>
  request(`/portal/verify/dataProtection/getTemplateBoundTagList`, {
    params: {
      ...data,
    },
  })
